export const LIST_COUNTRY_REQ = "LIST_COUNTRY_REQ";
export const LIST_COUNTRY_SUCCESS = "LIST_COUNTRY_SUCCESS";
export const LIST_COUNTRY_FAILURE = "LIST_COUNTRY_FAILURE";
